// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"18":"4f5d070d","49":"d6b2726e","55":"50ae9cff","60":"4c30be21","659":"4c79e7b2"}[chunkId] + ".css";
};